// extracted by mini-css-extract-plugin
export default {"messageValueContainer":"styles_messageValueContainer__3Fu+K","messageValue":"styles_messageValue__GlKh4","titleText":"styles_titleText__oXs8J"};